module.exports = __webpack_public_path__ + "static/media/initial.2894b7d6.jpg";